import {type FileInfo} from 'mattermost-redux/types/files';

export type LinkInfo = {
    has_preview_image: boolean;
    link: string;
    extension: string;
    name: string;
}

export function isFileInfo(info: FileInfo | LinkInfo): info is FileInfo {
    return 'id' in info;
}

export function isLinkInfo(info: FileInfo | LinkInfo): info is LinkInfo {
    return 'link' in info;
}
